var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "box view-nav-bar" }, [
      _c("div", { staticClass: "d-flex align-items-center w-100" }, [
        _c("span", { staticClass: "text-muted" }, [
          _vm._v("\n                Last "),
          _c("strong", [_vm._v(_vm._s(_vm.bucket.limit || 30))]),
          _vm._v(" Cinedata source files in "),
          _c("code", [_vm._v(_vm._s(_vm.bucket.folder))]),
          _vm._v(" "),
          _vm.rows.length
            ? _c("span", [
                _vm._v("\n                    — "),
                _c(
                  "strong",
                  { class: _vm.bucket.corrected_late ? "text-warning" : "" },
                  [_vm._v(_vm._s(_vm.bucket.corrected_late))]
                ),
                _vm._v(
                  "\n                    of " +
                    _vm._s(_vm.rows.length) +
                    " still changed more than " +
                    _vm._s(_vm.bucket.window_days) +
                    " days after their play date\n                "
                ),
              ])
            : _vm._e(),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.loading
      ? _c("div", { staticClass: "box" }, [
          _c(
            "div",
            { staticClass: "box-content text-center text-muted py-4" },
            [_vm._v("Loading…")]
          ),
        ])
      : !_vm.rows.length
      ? _c("div", { staticClass: "box" }, [
          _c(
            "div",
            { staticClass: "box-content text-center text-muted py-4" },
            [_vm._v("No source files found.")]
          ),
        ])
      : _c("div", { staticClass: "box" }, [
          _c("div", { staticClass: "box-content" }, [
            _c("table", { staticClass: "shx-table w-100 mt-2" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.rows, function (row) {
                  return _c("tr", { key: row.file }, [
                    _c(
                      "td",
                      [
                        _vm.bucket.git
                          ? _c(
                              "router-link",
                              {
                                attrs: {
                                  to: "/admissions/sources/" + row.file,
                                },
                              },
                              [_c("code", [_vm._v(_vm._s(row.file))])]
                            )
                          : _c("code", [_vm._v(_vm._s(row.file))]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to:
                                "/admissions/day?from=" +
                                row.day +
                                "&to=" +
                                row.day,
                            },
                          },
                          [_vm._v(_vm._s(row.day))]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _vm._v(_vm._s(_vm.formatInt(row.lines))),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _vm._v(_vm._s(_vm.formatSize(row.size))),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _vm._v(
                        _vm._s(row.revisions !== null ? row.revisions : "—")
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(_vm.formatDate(row.first_changed))),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(_vm.formatDate(row.last_changed))),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(row.days_after) +
                          "\n                            "
                      ),
                      row.days_after > _vm.bucket.window_days
                        ? _c(
                            "span",
                            {
                              staticClass: "badge badge-warning ml-1",
                              attrs: {
                                title:
                                  "Still corrected " +
                                  row.days_after +
                                  " days after the play date",
                              },
                            },
                            [_vm._v("⚠")]
                          )
                        : _vm._e(),
                    ]),
                  ])
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "text-muted small mt-2 mb-0" },
              [
                _vm._v(
                  "\n                One CSV per play date, straight from the\n                "
                ),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://bitbucket.org/brightfishbe/cinedata_raw/",
                      target: "_blank",
                      rel: "noopener",
                    },
                  },
                  [_vm._v("cinedata_raw")]
                ),
                _vm._v(
                  "\n                repository (line count includes the header row).\n                "
                ),
                _vm.bucket.git
                  ? [
                      _vm._v(
                        "\n                    Click a file to compare two of its revisions row by row.\n                    "
                      ),
                      _c("strong", [_vm._v("Revisions")]),
                      _vm._v(
                        " is the number of commits that touched the file,\n                    "
                      ),
                      _c("strong", [_vm._v("Days after")]),
                      _vm._v(
                        " the number of days between the play date and the last commit:\n                    a high value means Cinedata was still correcting that day's admissions long after the fact.\n                    ⚠ marks files changed more than " +
                          _vm._s(_vm.bucket.window_days) +
                          " days after their play date.\n                "
                      ),
                    ]
                  : [
                      _vm._v(
                        "\n                    The folder is not a git checkout, so dates are the file modification times.\n                "
                      ),
                    ],
              ],
              2
            ),
          ]),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("File")]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-100" }, [_vm._v("Play date")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-80" }, [_vm._v("Lines")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-80" }, [_vm._v("Size")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-80" }, [
          _vm._v("Revisions"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-140" }, [_vm._v("First seen")]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-140" }, [_vm._v("Last changed")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [
          _vm._v("Days after"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }